export default "__VITE_ASSET__9c8a2166__"